import { Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'

function ErrorBoundryFallback() {
  return (<>
    <Typography variant='caption'>
      An error has occurred. Please try again later. If the issue persists, contact our support team for assistance.
    </Typography>
  </>)
}

export default ErrorBoundryFallback